import { useState } from 'react';
import { CamaraComponent } from '../Custodia/CamaraComponent';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

const CapturaFotosEmpleado = ({ funcFoto }) => {
    const [displayModal, setDisplayModal] = useState(false);
    const [fotoCapturada, setFotoCapturada] = useState(null);

    const manejarFotoTomada = (archivoFoto) => {
        funcFoto(archivoFoto)
        setDisplayModal(false);
    };

    return (
        <div>
            <Button
                label="Tomar Foto"
                icon="pi pi-camera"
                onClick={() => setDisplayModal(true)}
            />

            {/* Dialog video para capturar foto */}
            <Dialog
                header="Cámara en Vivo"
                visible={displayModal}
                style={{ width: '90vw', maxWidth: '500px' }}
                onHide={() => setDisplayModal(false)}
            >
                <div className="flex flex-column align-items-center">
                    {displayModal && (
                        <CamaraComponent
                            initCamera={displayModal}
                            onSuccessPhoto={manejarFotoTomada}
                            mostrarBotonArchivos={true}
                        />
                    )}
                    <p className="mt-2 text-sm text-gray-600">
                        Apunta y presiona "Tomar Foto"
                    </p>
                </div>
            </Dialog>
        </div>
    );
};

export default CapturaFotosEmpleado;
